import { useEffect, useRef } from "react";

import { channelPath } from "@/hooks/dispatch/channelPath";
import type { ChannelList } from "@/models/repositories/Feed.ts";

export default function WebPipWindow({
  data,
  clickItem,
  dispatchEnabled,
}: {
  data: ChannelList[] | null | undefined;
  clickItem: (value: string) => void;
  /** Whether the workspace has the Dispatch page on, which is where a driver's channel then opens. */
  dispatchEnabled: boolean;
}) {
  const pipWindowContainer = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = pipWindowContainer.current;
    if (!container) return;

    const handleClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const button = target.closest("button");
      if (button && button.classList.contains("pip-window-container-button")) {
        const value = button.getAttribute("value");
        if (value) {
          clickItem(value);
        }
      }
    };
    container.addEventListener("click", handleClick);
    return () => {
      container.removeEventListener("click", handleClick);
    };
  }, [data, clickItem, pipWindowContainer]);

  return (
    <div className="pip-window-container" ref={pipWindowContainer}>
      <>
        <div className={`pip-window-container-count ${data?.length > 0 ? "active" : ""}`}>
          You have {data?.length ?? 0} unread channels
        </div>
        <div className="pip-window-container-list">
          {data?.map((item) => (
            <button
              className="pip-window-container-button"
              key={`pip-item-${item.id}`}
              value={channelPath({
                workspaceId: item.workspaceId,
                feedId: item.id,
                aliasMembershipId: item.aliasMembershipId,
                dispatchEnabled,
              })}
            >
              <span className="pip-item-title">{item.title}</span>
              <span className="red-dot" />
            </button>
          ))}
        </div>
      </>
    </div>
  );
}
